import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type LoginFormData, type Account, type LoginError, type ExistingLogin, type ChallengeContext} from './models';

const domain = 'LOGIN_V2';

export const {action: reset} = createAction(`${domain}/RESET`, (transition: any) => ({transition}));

export const {action: resetError} = createAction(`${domain}/RESET_ERROR`, () => ({}));

export const {action: changePin} = createAction(`${domain}/CHANGE_PIN`, (pin: string) => ({pin}));

export const {action: selectAccount} = createAction(`${domain}/SELECT_ACCOUNT`, (loginId: Account['loginId']) => ({
    loginId,
}));

export type RedirectConfig =
    | {
          skipRedirect: true;
      }
    | {
          redirectUrl: string;
      };

export const {
    action: credentialLogin,
    success: credentialLoginSuccess,
    failed: credentialLoginFailed,
    aborted: credentialLoginAborted,
} = createAction(
    `${domain}/CREDENTIAL_LOGIN`,
    (data: LoginFormData, redirectConfig?: RedirectConfig) => ({data, redirectConfig}),
    (response: {accessToken: string; justSignedUp?: boolean}, redirectConfig?: RedirectConfig) => ({
        response,
        redirectConfig,
    }),
    (error?: LoginError) => ({error}),
    (error?: LoginError) => ({error}),
);

export const {
    action: tokenLogin,
    success: tokenLoginSuccess,
    failed: tokenLoginFailed,
} = createAction(
    `${domain}/TOKEN_LOGIN`,
    (response: {token: string}, redirectConfig?: RedirectConfig) => ({
        response,
        redirectConfig,
    }),
    (response: {accessToken: string}, redirectConfig?: RedirectConfig) => ({
        response,
        redirectConfig,
    }),
    (error?: LoginError) => ({error}),
);

export const {action: credentialLoginForRedirect} = createAction(
    `${domain}/CREDENTIAL_LOGIN_FOR_REDIRECT`,
    (data: LoginFormData, redirectConfig?: RedirectConfig) => ({data, redirectConfig}),
);

export const {
    action: pinLogin,
    success: pinLoginSuccess,
    failed: pinLoginFailed,
} = createAction(
    `${domain}/PIN_LOGIN`,
    (
        pin: string,
        loginId: string,
        deviceId: string,
        redirectConfig?: RedirectConfig,
        shouldUseUserContext?: boolean,
    ) => ({
        pin,
        loginId,
        deviceId,
        redirectConfig,
        shouldUseUserContext,
    }),
    (response: any, loginId: string, redirectConfig?: RedirectConfig) => ({response, loginId, redirectConfig}),
    (error?: LoginError) => ({error}),
);

export const {
    action: fetchLoginsForDevice,
    success: fetchLoginsForDeviceSuccess,
    failed: fetchLoginsForDeviceFailed,
} = createAction(
    `${domain}/FETCH_LOGINS_FOR_DEVICE`,
    deviceId => ({deviceId}),
    (accounts: List<Account>, loginId?: Account['loginId']) => ({accounts, loginId}),
);

export const {
    action: removeAccount,
    success: removeAccountSuccess,
    failed: removeAccountFailed,
} = createAction(
    `${domain}/REMOVE_ACCOUNT`,
    (deviceId: string, loginId: string) => ({deviceId, loginId}),
    (loginId: string) => ({loginId}),
);

export const {action: setForceCredentials} = createAction(`${domain}/SET_FORCE_CREDENTIALS`, (force: boolean) => ({
    force,
}));

export const {
    action: testEmailForLogins,
    success: testEmailForLoginsSuccess,
    failed: testEmailForLoginsFailed,
} = createAction(
    `${domain}/TEST_EMAIL_FOR_LOGINS`,
    (email: string) => ({email}),
    (email: string, logins: List<ExistingLogin>) => ({email, logins}),
);

export const {action: resetEmailTest} = createAction(`${domain}/RESET_EMAIL_TEST`, () => ({}));

export const {action: showChallenge} = createAction(
    `${domain}/SHOW_CHALLENGE`,
    ({challenge, loginTLD}: {challenge: ChallengeContext; loginTLD?: string}) => ({
        challenge,
        loginTLD,
    }),
);
export const {action: resetChallenge} = createAction(`${domain}/RESET_CHALLENGE`, () => ({}));
